import assignmentService from 'ApiService/Student/assignmentService';
import TestComponent from '../Index';

const Index = () => {
  const title = 'No Weekly Assignment Assigned Yet.';
  const fetchWeekly = async () => {
    return await assignmentService.getWeeklyAssignment();
  };
  return <TestComponent fetchTests={fetchWeekly} NoData={title} />;
};

export default Index;
